export default function (elName) {
  return {
    data () {
      return {
        windowWidth: 0,
        windowHeight: 0
      }
    },

    mounted () {
      this.$nextTick(function () {
        window.addEventListener('resize', this.getWindowWidth)
        window.addEventListener('resize', this.getWindowHeight)
        window.addEventListener('resize', this.rescale)

        //Init
        this.getWindowWidth()
        this.getWindowHeight()
        this.rescale()
      })
    },

    methods: {
      getWindowWidth () {
        this.windowWidth = document.documentElement.clientWidth
      },

      getWindowHeight () {
        this.windowHeight = document.documentElement.clientHeight
      },

      rescale () {
        let elem = document.getElementById(elName),
          widthHeader = document.querySelector('header_container')
        if (elem) {
          // 1140px is width of sankei header ( 1495 - 1140 = 355)
          // 1140px is width of sankei header
          // 1495px is width of input form
          let height = elem.offsetHeight,
            width = elem.offsetWidth,
            redundantWidth = this.windowWidth > 768 ? this.centerPos(widthHeader) : 0,
            ratio = ((this.windowWidth - 60) - redundantWidth) / 1495 > 1 ? 1 : ((this.windowWidth - 60) -
              redundantWidth) / 1495
          elem.style.transform = 'scale(' + ratio + ')'
          elem.parentElement.style.height = height * ratio + 100 + 'px'
          elem.parentElement.style.width = width * ratio + 1 + 'px'
          elem.parentElement.style.overflow = 'hidden'
        }
      },
      centerPos (width) {
        return (this.windowWidth - width) / 2
      }
    }
  }
}
